module.exports = __webpack_public_path__ + "img/cheapcomfort-logo.3e99546e.svg";